import { IconLoader2 } from '@tabler/icons-react';

export function PageLoader({ minHeight = '400px', text = 'Loading...' }) {
    return (
        <div className="flex flex-col items-center justify-center gap-10" style={{ minHeight }}>
            <IconLoader2 size={32} className="animate-spin text-primary" />
            <p className="text-sm text-text-secondary">{text}</p>
        </div>
    );
}

export function TableLoader({ text = 'Loading...' }) {
    return (
        <div className="flex items-center justify-center gap-8 py-30 text-text-secondary">
            <IconLoader2 size={16} className="animate-spin" />
            <span className="text-sm">{text}</span>
        </div>
    );
}
